import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import logo from '../../images/logo-2.svg';
import DrPereira from '../../images/dr-pereira.jpg';
import './AboutPage.scss';

const AboutPage = () => {
    return (
        <Fragment>
            <Navbar Logo={logo} hclass={'wpo-site-header wpo-site-header-s2'} isSecondary={true} />

            {/* Hero Section */}
            <section className="about-hero-section">
                <div className="hero-overlay"></div>
                <div className="container">
                    <div className="hero-content">
                        <h1>About Dr. Eugene Pereira</h1>
                        <p className="hero-subtitle">
                            Leading the interventional pain management specialist with over 20 years of
                            <br />
                            experience in advanced regenerative medicine and cellular therapies
                        </p>
                    </div>
                </div>
            </section>

            {/* Medical Journey & Professional Background */}
            <section className="medical-journey-section">
                <div className="journey-image-background"></div>
                <div className="container">
                    <div className="row align-items-stretch">
                        <div className="col-lg-6 col-md-12 order-1 order-lg-1">
                            <div className="journey-content">
                                <h2 className="section-title-teal">My Medical Journey &amp; Professional Background</h2>
                                <p className="journey-text">
                                    After completing my medical training in anesthesiology at West Virginia University,
                                    I discovered my calling in interventional pain management. Two decades of practice
                                    revealed the limitations of conventional approaches—temporary relief that failed to
                                    address root causes. This led me to pioneer regenerative medicine protocols using
                                    advanced cellular therapies, where I&apos;ve witnessed genuine healing in patients
                                    who had exhausted traditional options.
                                </p>

                                <div className="medical-education">
                                    <h3 className="education-title">Medical Education</h3>
                                    <ul className="education-list">
                                        <li>
                                            <strong>MD:</strong> St. John&apos;s Medical College, Bangalore, India (1991)
                                        </li>
                                        <li>
                                            <strong>Internship:</strong> Transitional Surgery, Maimonides Medical Center, Brooklyn, NY
                                        </li>
                                        <li>
                                            <strong>Residency:</strong> Anesthesiology, West Virginia University (1995-1998)
                                        </li>
                                        <li>
                                            <strong>Fellowship:</strong> Anesthesiology, West Virginia University (1999-2000)
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 order-2 order-lg-2">
                            <div className="journey-image-column">
                                {/* Image is set as background in CSS */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Professional Excellence */}
            <section className="professional-excellence-section">
                <div className="container">
                    <h2 className="section-title-center">Professional Excellence</h2>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="excellence-card">
                                <div className="icon-wrapper">
                                    <i className="fa-solid fa-medal"></i>
                                </div>
                                <h3>Board Certified</h3>
                                <p>
                                    FIPP, ABIPP certified with 20+ years
                                    <br />
                                    interventional pain management
                                    <br />
                                    expertise
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="excellence-card">
                                <div className="icon-wrapper">
                                    <i className="fa-solid fa-microscope"></i>
                                </div>
                                <h3>Clinical Innovation</h3>
                                <p>
                                    Leading Florida&apos;s advanced cellular
                                    <br />
                                    therapy protocols and training medical
                                    <br />
                                    professionals
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="excellence-card">
                                <div className="icon-wrapper">
                                    <i className="fa-solid fa-hospital"></i>
                                </div>
                                <h3>Hospital Affiliations</h3>
                                <p>
                                    Sarasota Memorial Hospital, Florida
                                    <br />
                                    Saint Mary&apos;s Regional Medical Center, Maine
                                    <br />
                                    Lee Memorial Hospital, Florida
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* My Approach to Patient Care */}
            <section className="patient-care-section section-padding">
                <div className="container">
                    <h2 className="section-title-center">My Approach to Patient Care</h2>
                    <p className="care-subtitle">
                        My philosophy centers on treating the root cause of your condition, not just managing symptoms.
                        Every patient receives a comprehensive evaluation and personalized regenerative medicine protocol.
                    </p>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="care-card">
                                <div className="care-image">
                                    <div className="circle-image">
                                        <img src="/evaluation.jpg" alt="Comprehensive Evaluation" />
                                    </div>
                                </div>
                                <h3>Comprehensive Evaluation</h3>
                                <p>
                                    Thorough assessment combining advanced diagnostics with detailed consultation
                                    to identify optimal treatment pathways.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="care-card">
                                <div className="care-image">
                                    <div className="circle-image">
                                        <img src="/treatments.jpg" alt="Personalized Treatment Plans" />
                                    </div>
                                </div>
                                <h3>Personalized Treatment Plans</h3>
                                <p>
                                    Each protocol is tailored using the most appropriate cellular therapies
                                    for your specific condition and goals.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="care-card">
                                <div className="care-image">
                                    <div className="circle-image">
                                        <img src="/technology.jpg" alt="Advanced Technology" />
                                    </div>
                                </div>
                                <h3>Advanced Technology</h3>
                                <p>
                                    Utilizing cutting-edge regenerative medicine techniques and the latest
                                    FDA-approved cellular therapies.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Professional Impact & Recognition */}
            <section className="professional-impact-section">
                <div className="container">
                    <h2 className="section-title-center">Professional Impact &amp; Recognition</h2>

                    {/* Amped Therapeutics - Image Left */}
                    <div className="impact-row">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 order-2 order-lg-1">
                                <div className="impact-image">
                                    <img src="/amped-logo.jpg" alt="Amped Therapeutics" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 order-1 order-lg-2">
                                <div className="impact-content">
                                    <h3>Founder &amp; Medical Director Amped Therapeutics</h3>
                                    <p>
                                        Leading Florida&apos;s most innovative regenerative medicine practice,
                                        Amped Therapeutics represents the cutting edge of cellular therapy treatments.
                                        Through this groundbreaking practice, I&apos;ve established Florida as a destination
                                        for advanced regenerative treatments previously only available internationally.
                                    </p>
                                    <p>
                                        Amped Therapeutics leverages Florida&apos;s progressive stem cell legislation to
                                        offer patients access to Wharton&apos;s jelly MSCs, exosome therapies, and advanced
                                        cellular treatments through our unique concierge medical model serving patients
                                        throughout Florida and the Southeast.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Medical Education & Industry Leadership - Image Right */}
                    <div className="impact-row">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12">
                                <div className="impact-content">
                                    <h3>Medical Education &amp; Industry Leadership</h3>
                                    <p>
                                        Dr. Pereira extends his expertise beyond patient care through comprehensive
                                        medical education and industry leadership. He regularly trains fellow physicians
                                        in advanced procedural techniques and regenerative medicine protocols across
                                        multiple medical institutions. As a featured presenter at Sarasota Memorial
                                        Hospital lecture series and international pain management conferences, he shares
                                        cutting-edge research and clinical insights with the global medical community.
                                        Additionally, he serves as a consultant for biomedical equipment companies,
                                        contributing to device development and safety protocol establishment that advances
                                        the field of interventional pain management.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="impact-image">
                                    <img src="/dr-pereira-conference.jpg" alt="Dr. Pereira at Conference" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="about-cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Discuss Your Specific Condition?</h2>
                        <p>
                            Schedule a comprehensive consultation to explore if regenerative medicine is right for you
                        </p>
                        <Link to="/contact" className="theme-btn">
                            Schedule My Consultation
                        </Link>
                    </div>
                </div>
            </section>

            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    );
};

export default AboutPage;
